/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="coupons-manager">
    <absolute-loader :show-loader="showLoader" mode="fixed" />
    <div class="add-coupon">
      <coupon @loading="setLoader" />
    </div>
    <div class="coupons-list">
      <ul class="nav">
        <li v-show="userCoupons.length === 0 && activeCoupons.length === 0">
          <p class="text-center">{{ $t('no-coupons-added')}}</p>
        </li>
        <li v-for="coupon in activeCoupons" :key="coupon.code">
          <coupon-tile :coupon="coupon" :isActive="true" @remove-coupon="removeCoupon" @add-coupon="addCoupon" />
        </li>
        <li v-for="coupon in userCoupons" :key="coupon.code">
          <coupon-tile :coupon="coupon" @remove-coupon="removeCoupon" @add-coupon="addCoupon" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { toast } from 'theme/modules/notifications'
// import AbsoluteLoader from 'theme/components/AbsoluteLoader/AbsoluteLoader'
// import Coupon from 'theme/components/Checkout/Cart/Coupon'
// import CouponTile from 'theme/components/Checkout/Cart/Coupons/CouponTile.vue'

export default {
  name: 'CouponsManager',
  data () {
    return {
      showLoader: false
    }
  },
  computed: {
    activeCoupons () {
      return this.$store.getters['cart/getAppliedCoupons']
    },
    userCoupons () {
      return this.$store.getters['userAdmin/getCoupons'].filter((coupon) => {
        return !this.activeCoupons.find(actC => actC.code.toUpperCase() === coupon.code.toUpperCase())
      })
    }
  },
  methods: {
    scrollToTop () {
      document.getElementsByClassName('wrapp-bottombar__content')[0].scrollTo(0, 0)
    },
    setLoader (value) {
      this.showLoader = value
    },
    removeCoupon (coupon) {
      const _this = this
      this.setLoader(true)
      return this.$store.dispatch('cart/deleteCoupon', { cartId: this.$store.state.cart.cartId, couponId: coupon.coupon_item_id })
        .catch(error => {
          const msg = error.response.data && error.response.data.message ? _this.$t(error.response.data.message) : _this.$t('GenericError')
          toast.error(msg)
          this.setLoader(false)
        })
        .then(() => {
          return this.$store.dispatch('cart/totals')
            .finally(() => {
              this.setLoader(false)
              this.scrollToTop()
              toast.success(this.$t('coupon-successfully-removed'))
            })
        })
    },
    addCoupon (coupon) {
      const _this = this
      this.setLoader(true)
      return this.$store.dispatch('cart/addCoupon', coupon.code)
        .then(res => {
          let errorsCall = res.errors
          if (errorsCall && errorsCall.length) {
            toast.error(errorsCall[0].message)
            this.setLoader(false)
          } else {
            // success
            return this.$store.dispatch('cart/totals')
              .finally(() => {
                this.scrollToTop()
                this.setLoader(false)
                toast.success(this.$t('coupon-successfully-added'))
              })
          }
        })
        .catch(error => {
          const msg = error.response.data && error.response.data.message ? _this.$t(error.response.data.message) : _this.$t('GenericError')
          toast.error(msg)
          this.setLoader(false)
        })
    }
  },
  components: {
    AbsoluteLoader: () => import('theme/components/AbsoluteLoader/AbsoluteLoader'),
    Coupon: () => import('theme/components/Checkout/Cart/Coupon'),
    CouponTile: () => import('theme/components/Checkout/Cart/Coupons/CouponTile')
  }
}
</script>
